import angular from 'angular';
import '../../layouts.module';
import template from './privacy-policy.component.html';
import './privacy-policy.component.scss';

angular.module('app.layouts').component('cpPrivacyPolicy', {
  template
});
